import Vue from 'vue'   //引入Vue
import Router from 'vue-router'  //引入vue-router
Vue.use(Router)

import index from '../pages/Login.vue'
import Enrollsuper from '../pages/Enrollsuper.vue'
import Userdata from '../pages/Userdata.vue'
import OrganizationList from '../pages/OrganizationList.vue'
import GatewayList from '../pages/GatewayList.vue'
import NetworkList from '../pages/NetworkList.vue'
import NetworkGateway from '../pages/NetworkGateway.vue'
import NetworkTerminal from '../pages/NetworkTerminal.vue'
import NetworkDevice from '../pages/NetworkDevice.vue'
import NetworkTime from '../pages/NetworkTime.vue'
import NetworkTask from '../pages/NetworkTask.vue'
import Productsn from '../pages/Productsn.vue'
import Productcenter from '../pages/Productcenter.vue'
import Menudata from '../pages/Menudata.vue'
import Roledata from '../pages/Roledata.vue'
import Admindata from '../pages/Admindata.vue'
//import networksindex from '../pages/networksindex.vue'
// import networksindex from '../pages/statics.vue'
import Overview from '../pages/Homepage.vue'
import Networks from '../pages/Networks.vue'
import Netdetail from '../pages/Netdetail.vue'
import Forgot from '../pages/Forgot.vue'
import Addnetworks from '../pages/Addnetworks.vue'
import Equipment from '../pages/Equipment.vue'
import Equipments from '../pages/Equipments.vue'
import Minedata from '../pages/Minedata.vue'
import Changemobile from '../pages/Changemobile.vue'
import Project from '../pages/Project.vue'
import Usercharge from '../pages/Usercharge.vue'
import SafeUser from '../pages/SafeUser.vue'
import Myorder from '../pages/Myorder.vue'
import OrderDetails from '../pages/OrderDetails.vue'
import SystemSettings from '../pages/SystemSettings.vue'
import ValueAdded from '../pages/ValueAdded.vue'
import BackupRecovery from '../pages/BackupRecovery.vue'
import Notice from '../pages/Notice.vue';


// 路由重复点击报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
        },
        {
            path: '/Enrollsuper',
            name: 'Enrollsuper',
            component: Enrollsuper,
        },
        {
            path: '/UserData',
            name: 'UserData',
            component: Userdata,
        },
        {
            path: '/OrganizationList',
            name: 'OrganizationList',
            component: OrganizationList,
        },
        {
            path: '/GatewayList',
            name: 'GatewayList',
            component: GatewayList,
        },
        {
            path: '/NetworkList',
            name: 'NetworkList',
            component: NetworkList,
        },
        {
            path: '/NetworkGateway',
            name: 'NetworkGateway',
            component: NetworkGateway,
        },
        {
            path: '/NetworkTerminal',
            name: 'NetworkTerminal',
            component: NetworkTerminal,
        },
        {
            path: '/NetworkDevice',
            name: 'NetworkDevice',
            component: NetworkDevice,
        },
        {
            path: '/NetworkTime',
            name: 'NetworkTime',
            component: NetworkTime,
        },
        {
            path: '/NetworkTask',
            name: 'NetworkTask',
            component: NetworkTask,
        }, {
            path: '/ProductSn',
            name: 'ProductSn',
            component: Productsn,
        }, {
            path: '/ProductCenter',
            name: 'ProductCenter',
            component: Productcenter,
        },
        {
            path: '/MenuData',
            name: 'MenuData',
            component: Menudata,
        },
        {
            path: '/RoleData',
            name: 'RoleData',
            component: Roledata,
        },
        {
            path: '/AdminData',
            name: 'AdminData',
            component: Admindata,
        },
        {
            path: '/Overview',
            name: 'Overview',
            component: Overview,
        },
        {
            path: '/Networks',
            name: 'Networks',
            component: Networks,
        },
        {
            path: '/NetDetail',
            name: 'NetDetail',
            component: Netdetail,
        },
        {
            path: '/Forgot',
            name: 'Forgot',
            component: Forgot,
        },
        {
            path: '/AddNetworks',
            name: 'AddNetworks',
            component: Addnetworks,
        },
        {
            path: '/Equipment',
            name: 'Equipment',
            component: Equipment,
        },
        {
            path: '/Equipments',
            name: 'Equipments',
            component: Equipments,
        },
        {
            path: '/MineData',
            name: 'MineData',
            component: Minedata,
        },
        {
            path: '/ChangeMobile',
            name: 'ChangeMobile',
            component: Changemobile,
        },
        {
            path: '/Project',
            name: 'Project',
            component: Project,
        },
        {
            path: '/UserCharge',
            name: 'UserCharge',
            component: Usercharge,
        },
        {
            path: '/SafeUser',
            name: 'SafeUser',
            component: SafeUser,
        },
        {
            path: '/MyOrder',
            name: 'MyOrder',
            component: Myorder,
        },
        {
            path: '/OrderDetails',
            name: 'OrderDetails',
            component: OrderDetails,
        },
        {
            path: '/SystemSettings',
            name: 'SystemSettings',
            component: SystemSettings,
        },
        {
            path: '/ValueAdded',
            name: 'ValueAdded',
            component: ValueAdded,
        },
        {
            path: '/BackupRecovery',
            name: 'BackupRecovery',
            component: BackupRecovery,
        },
        {
            path: '/Notice',
            name: 'Notice',
            component: Notice,
        },
    ],
})